"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var _TimelineFiltersStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFiltersStore"));

var _TimelineFavoriteEventsOverrideStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFavoriteEventsOverrideStore"));

var TimelineOverridableFavoriteEventsDependency = {
  stores: [_TimelineFiltersStore.default, _TimelineFavoriteEventsOverrideStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType;
    var favoriteEventsOverride = (0, _get.default)('eventTypes', _TimelineFavoriteEventsOverrideStore.default.get(objectType));
    return favoriteEventsOverride || _TimelineFiltersStore.default.get(objectType) && _TimelineFiltersStore.default.get(objectType).get('eventTypes');
  }
};
var _default = TimelineOverridableFavoriteEventsDependency;
exports.default = _default;
module.exports = exports.default;